@import '~style-sheet-helpers/core.less';

.label {
  padding-top: 10px;
  grid-column-start: 1;
}

.link {
  font-size: 12px;
}

.duties-and-taxes__inline-message {
  margin-top: 4px;
}

.duties-and-taxes-banner {
  grid-column: 1/4;
}

.duties-and-taxes-banner__title,
.duties-and-taxes-banner__message {
  margin: 0;
}

.duties-and-taxes-banner__title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
}

.prepay-duty-alert-modal__modal-body {
  padding: 16px;
  padding-bottom: 64px;
  line-height: 22px;
}

.bulk-alert-modal__checkbox {
  font-size: 16px;
  margin-bottom: 16px;
}
